import type IImage from '../../../models/press/image.model';

export class ImageApiModel {
  public static mapToBusinessModel(apiModel: ImageApiModel): IImage {
    return {
      caption: apiModel.caption,
      url: apiModel.url,
    };
  }

  public caption!: string;
  public url!: string;
}

